<template>
  <section class="magazine-button-bar">
    <BaseButton href="#" variant="primary" width="sm" class="magazine-button-bar__btn">
      <BaseIcon name="get_app" size="18"></BaseIcon>
      <span>&nbsp;Download Hi-Res</span>
    </BaseButton>
    <BaseButton href="#" variant="primary" width="sm" class="magazine-button-bar__btn">
      <BaseIcon name="get_app" size="18"></BaseIcon>
      <span>&nbsp;Download Lo-Res</span>
    </BaseButton>
  </section>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'

export default {
  name: 'MagazineButtonBar',
  components: {
    BaseButton,
    BaseIcon
  }
}
</script>

<style lang="postcss">
.magazine-button-bar {
  @apply  flex flex-col;
}
.magazine-button-bar__btn {
  @apply flex-1 flex justify-center rounded-full w-full;
}
.magazine-button-bar__btn:nth-child(1) {
  @apply mb-4;
}
.magazine-button-bar__btn span {
  @apply whitespace-no-wrap px-0;
}

@screen md {
  .magazine-button-bar {
    @apply  flex-row;
  }
  .magazine-button-bar__btn:nth-child(1) {
  @apply mr-2 mb-0;
}
.magazine-button-bar__btn:nth-child(2) {
  @apply ml-2;
}
}
/* RW AMEND FOR 2022 */
/* .magazine-button-bar a:first-of-type span:last-of-type,
.magazine-button-bar a:last-of-type span:last-of-type {
  color: #00893f;
  position: relative;
}
.magazine-button-bar a:first-of-type span:last-of-type::after,
.magazine-button-bar a:last-of-type span:last-of-type::after {
  display: inline-block;
  color: #ffffff;
  position: absolute;
  left: 0;
}
.magazine-button-bar a:first-of-type span:last-of-type::after {
  content: 'Lifestyle';
}
.magazine-button-bar a:last-of-type span:last-of-type::after {
  content: 'Packshot';
}
.magazine-button-bar a:hover span:last-of-type {
  color: #007435;
} */
</style>
